import { Skeleton } from "@/components/ui/skeleton";
import { motion } from "framer-motion";

const ServiceDetailSkeleton = () => {
  return (
    <div className="min-h-screen gradient-mesh pb-32 md:pb-36 overflow-hidden">
      {/* Sticky Header Mock */}
      <div className="sticky top-0 z-50 glass-strong border-b" style={{ paddingTop: 'env(safe-area-inset-top)' }}>
        <div className="max-w-3xl mx-auto flex items-center gap-3 h-14 md:h-16 px-4 md:px-6">
          <Skeleton className="h-8 w-8 rounded-full" />
          <Skeleton className="h-5 w-32" />
        </div>
      </div>

      <main className="max-w-3xl mx-auto px-4 md:px-6 space-y-6 md:space-y-8 pt-4 md:pt-6">
        {/* Hero Skeleton - Matching Gradient Styling */}
        <div className="relative rounded-3xl bg-gradient-to-br from-secondary/80 via-accent/50 to-secondary/80 overflow-hidden p-6 md:p-8 flex flex-col sm:flex-row items-center gap-5 md:gap-8 shadow-card border border-border/10">
          <Skeleton className="h-28 w-28 sm:h-32 sm:w-32 md:h-36 md:w-36 rounded-2xl shadow-sm" />
          <div className="flex-1 space-y-3 w-full">
            <Skeleton className="h-8 w-3/4" />
            <Skeleton className="h-4 w-full" />
            <div className="flex gap-4 justify-center sm:justify-start">
               <Skeleton className="h-5 w-12" />
               <Skeleton className="h-5 w-24" />
               <Skeleton className="h-5 w-16" />
            </div>
          </div>
        </div>

        {/* Trust Pills */}
        <div className="flex items-center gap-4 justify-center">
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-3 w-20" />
            <Skeleton className="h-3 w-20" />
        </div>

        {/* Sub-Service List Skeleton */}
        <div className="space-y-4">
          <Skeleton className="h-5 w-32 mb-2" />
          {[1, 2, 3].map((i) => (
            <div key={i} className="rounded-2xl bg-card border border-border/50 p-4 md:p-5 shadow-sm space-y-4">
                <div className="flex justify-between items-start">
                    <div className="space-y-2 flex-1">
                        <Skeleton className="h-5 w-1/3" />
                        <Skeleton className="h-3 w-2/3" />
                    </div>
                    <Skeleton className="h-5 w-10 ml-4" />
                </div>
                
                <div className="flex justify-between items-center gap-4 pt-1">
                    <div className="flex gap-3">
                        <Skeleton className="h-3 w-12" />
                        <Skeleton className="h-3 w-16" />
                    </div>
                    <div className="flex gap-2">
                        <Skeleton className="h-8 w-16 rounded-xl" />
                        <Skeleton className="h-8 w-24 rounded-xl" />
                    </div>
                </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default ServiceDetailSkeleton;
